import { render } from "./TheHeader.vue?vue&type=template&id=a2213c06"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=a2213c06&lang=css"
script.render = render

export default script